import { render } from "./DefaultPagination.vue?vue&type=template&id=2b6d1067"
import script from "./DefaultPagination.vue?vue&type=script&lang=js"
export * from "./DefaultPagination.vue?vue&type=script&lang=js"
script.render = render

export default script